const BASE_URL = process.env.REACT_APP_API_HOST as string;
export const ApiPath = {
  getOnlineMenuWeb: "/api/get/GetOnlineMenuWeb",
  getOnlineMenuLanguages: "/api/get/GetOnlineMenuLanguages",
  getOnlineMenuCompany: "/api/get/getCompanyInfoWeb",
  setOnlineMenuStatistic: "/api/insert/OnlineMenuStatistic",
  getOnlineMenuHomeData: "api/get/getCompanyHomepageInfo",
  getCompanyProductsWeb: "/api/get/getCompanyProductsWeb",
};

export const getImageByName = (text: string) => `${BASE_URL}/image/${text}`;
export const getImage = (path: string) => `${BASE_URL}/image?image=${path}`;

///     SUCCESS = 1000,
///
///     INPUT_VALIDATION_ERROR = 1100,
///     INVALID_ACCESS_TOKEN = 1101,
///     INVALID_REFRESH_TOKEN = 1102,
///     TOKEN_EXPIRED = 1103,
///     REQUEST_TOO_LARGE = 1104,
///     REQUEST_SYNTAX_ERROR = 1105,
///     FILE_UPLOAD_ERROR = 1106,
///     FILE_NOT_FOUND = 1107,
///     WRONG_FILE_TYPE = 1108,
///     REQUEST_GENERAL_ERROR = 1108,
///     INVALID_AUTHORIZATION_KEY = 1109,
///     INVALID_INPUT = 1110,
///     INVALID_HEADER_KEYS = 1111,
///     MAIL_SEND_ERROR = 1112,
///     MODEL_HAS_NOT_ID = 1113,
///     POSSIBLE_CONNECTION_ERROR = 1190,
///     BEFORE_OPERATION_ERROR = 1200,
///     AFTER_OPERATION_ERROR = 1201,
///     INSERT_ERROR = 1202,
///     UPDATE_ERROR = 1203,
///     NOT_ENTITY_FOUND = 1300,
///     NOT_REPORT_FOUND = 1301,
///     ID_ENCRYPT_NOT_CONVERTED = 1350,
///     ID_DECRYPT_NOT_CONVERTED = 1351,
///
///     DATABASE_ERROR = 1400,
///
///     USER_PRIVILEGE_NOT_FOUND = 1500,
///     FORBIDDEN_ENDPOINT = 1501,
///
///     INVALID_EMAIL_PASSWORD = 1600,
///     HAS_USER_WITH_SAME_EMAIL = 1601,
///     WRONG_USER_ACTIVATE_URL = 1602,
///     HAS_COMPANY_WITH_SAME_TITLE = 1603,
///     USER_NOT_ACTIVATED = 1604,
///     USER_NOT_FOUND = 1605,
///     PASSWORDS_NOT_MATCH = 1606,
///     INVALID_PASSWORD = 1607,
///     HAS_COMPANY_WITH_SAME_SUBDOMAIN = 1608,
///
///     COMPANY_DONT_HAVE_AVAILABLE_PURCHASED_PACKAGE = 1700,
///     USER_COMPANY_DONT_HAVE_PRODUCT = 1701,
///     COMPANY_ALREADY_HAS_THE_PRODUCT = 1702,
///     COMPANY_TYPE_IS_WRONG = 1703,
///
///     ONLINE_MENU_ALREADY_HAS_THE_LANGUAGE = 1801,
